import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { BiMessageModule } from '../bi-message/bi-message.module';
import { CompanyModule } from '../company/company.module';
import { Modules } from '../entity/module.entity';
import { ModuleController } from './module.controller';
import { ModuleService } from './module.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      Modules
    ]),
    forwardRef(()=> CompanyModule),
    forwardRef(()=> BiMessageModule)
  ],
  controllers: [ModuleController],
  providers: [ModuleService, ApplicationExceptionHandler],
  exports: [ModuleService]
})
export class ModuleModule { }

